import Handlebars from "../handlebars/handlebars";
import modalHtml from "./modal.default.hbs";
import bodyLockService from "../ui/bodyLockService";

document.addEventListener('keydown', handleKeydown, false);

const defaultTemplateFn = modalHtml;
let DEFAULT_DELAY = 250;
const CONTAINER_CLASS = 'modalContainer';
const CONTAINER_INACTIVE_CLASS = 'modalContainer_inactive';
const CANCEL_ACTION_SELECTOR = '.js-action--modal-cancel';
const CONTENT_ELEMENT_SELECTOR = '.js-element--modal-content';
let modals = [];

function addToStack (m) {
    if (!modals.length) {
        bodyLockService.lock();
    }

    modals.push(m);
}

function removeFromStack (m) {
    modals = modals.filter(modal => modal !== m);

    if (!modals.length) {
        bodyLockService.unlock();
    }
}

function handleKeydown (e) {
    if (e.shiftKey || e.ctrlKey || e.metaKey || e.key !== 'Escape' || !modals.length || !modals[modals.length - 1].keyboard) {
        return;
    }

    modals[modals.length - 1].cancel();
}

class Modal {
    setDefaultDelay (delay) {
        DEFAULT_DELAY = parseInt(delay, 10) || DEFAULT_DELAY;
    }

    constructor (modalOptions = {}) {
        // Process the modal markup
        const element = document.createElement('div');
        element.classList.add(CONTAINER_CLASS);
        element.classList.add(CONTAINER_INACTIVE_CLASS);

        const templateOptions = {
            title: modalOptions.title || null,
            showCancel: modalOptions.hasOwnProperty('showCancel') ? !!modalOptions.showCancel : true,
            content: modalOptions.content || null,
            classes: modalOptions.classes || [],
        };

        element.innerHTML = (modalOptions.template || defaultTemplateFn)(templateOptions);

        // Add behavior
        const cancelButtons = element.querySelectorAll(CANCEL_ACTION_SELECTOR);
        cancelButtons.forEach(btn => btn.addEventListener('click', e => {
            e.preventDefault();
            this.cancel();
        }, false));

        const delay = parseInt(modalOptions.delay, 10) || DEFAULT_DELAY;
        const remove = () => {
            element.classList.add(CONTAINER_INACTIVE_CLASS);
            removeFromStack(this);
            setTimeout(() => document.body.removeChild(element), delay);
        }

        // Add public properties to instance
        this.keyboard = modalOptions.hasOwnProperty('keyboard') ? !!modalOptions.keyboard : templateOptions.showCancel;
        this.promise = new Promise((resolve, reject) => {
            this.close = value => {
                resolve(value);
                remove();
            }

            this.cancel = reason => {
                reject(reason);
                remove();
            };
        });

        // Initialize child controller if one was passed
        modalOptions.controller && modalOptions.controller.constructor === Function && new modalOptions.controller(this, element.querySelector(CONTENT_ELEMENT_SELECTOR), ...(modalOptions.controllerInject || []));

        // Add modal to DOM
        addToStack(this);
        requestAnimationFrame(() => {
            (modalOptions.appendTo || document.body).appendChild(element);
            requestAnimationFrame(() => {
                element.classList.remove(CONTAINER_INACTIVE_CLASS)
            });
        })
    }
}
export default Modal;